export default __webpack_public_path__ + "static/media/SuperiorClosed.fe7ee070.jpg";